module.exports = __webpack_public_path__ + "static/media/extra_oral_right.55358f4a.png";